import { FLEX_COLUMN_GAP } from './constants.js';
import { createContext } from 'react';

export const FlexContext = createContext({
  gap: FLEX_COLUMN_GAP,
  reversed: false,
});
